export default __webpack_public_path__ + "static/media/polska2.3ae6ed7e.JPG";